module.exports = __webpack_public_path__ + "static/mike-98c94e79b68b9877e41a96fcdcd638b1.jpg";